import React from 'react';
import moment from 'moment';
import { DeleteOutlined } from '@ant-design/icons';

export const popup = ({ onDelete }) => {
    return [
        {
            title: '번호',
            dataIndex: 'index',
            align: 'center',
            width: '70px',
        },
        {
            title: '공개여부',
            dataIndex: 'isPublic',
            align: 'center',
            render: isPublic => <span>{isPublic === true ? '공개' : isPublic === false ? '비공개' : null}</span>,
        },
        {
            title: '팝업 타이틀',
            dataIndex: 'title',
        },
        {
            title: '팝업 이미지',
            dataIndex: 'photo',
            render: photo => (photo ? <img src={photo} alt='팝업 이미지' style={{ width: '50px', height: '50px', objectFit: 'cover' }} /> : null),
        },
        {
            title: '등록일',
            dataIndex: 'createdAt',
            align: 'center',
            render: createdAt => <span>{moment(createdAt).format('YY.MM.DD HH:mm') || '0'}</span>,
        },
        {
            title: '삭제',
            dataIndex: 'valid',
            align: 'center',
            width: '60px',
            render: (valid, { _id }) => (
                <DeleteOutlined
                    onClick={e => {
                        e.preventDefault();
                        e.stopPropagation();

                        onDelete({ _id });
                    }}
                />
            ),
        },
    ];
};
